import {Container, Graphics, Loader, Text} from "pixi.js";
import {Vector} from "./i.js"; // ./vector.js
import {G, VERSION} from "./i.js"; // ./dump.js
import {keyboard} from "./i.js"; // ./keyboard.js
import {UIUtils, Clicker} from "./i.js"; // ./ui/utils.js
import {Game} from "./i.js"; // ./game.js

class Menu {
	constructor() {
		this.display = new Container();
		this.game = null;
		this._mainMenu = new Container();
		this.display.addChild(this._mainMenu);

		this._background = new Graphics();
		this._startButton = new Text("Click to start", UIUtils.getFont(0xffffff));
		this._version = new Text(
			`Project Guesstimator\n${VERSION}`,
			UIUtils.getFont(0xffffff, {align: "center"})
		);
		this._mainMenu.addChild(this._background, this._startButton, this._version);
		this._clicker = new Clicker(this._mainMenu);

		this._gameStarted = false;
	}

	update(dt, screenSize, fps) {
		if (this._gameStarted) {
			this.game.update(dt, screenSize, fps);
			return;
		}

		if (this._clicker.wasClicked() && !this._gameStarted) {
			this._gameStarted = true;
			this.display.removeChild(this._mainMenu);
			this.game = new Game();
			this.display.addChild(this.game);
		}

		let rulerLength = UIUtils.getRulerLength(screenSize);

		this._background
			.clear()
			.beginFill(0x000000)
			.drawRect(0, 0, screenSize.x, screenSize.y);
		this._startButton.style.fontSize = 0.05 * rulerLength;
		let startButtonPosition = new Vector(
			screenSize.x / 2 - this._startButton.width / 2,
			screenSize.y / 2 - this._startButton.height / 2
		).round();
		this._startButton.position.copyFrom(startButtonPosition);
		this._version.style.fontSize = 0.02 * rulerLength;
		let versionPosition = new Vector(
			screenSize.x / 2 - this._version.width / 2,
			screenSize.y - 0.05 * rulerLength - this._version.height / 2
		).round();
		this._version.position.copyFrom(versionPosition);

		this._clicker.clearStuff();
	}
}



let menu;



Loader.shared
	.add([
		"images/asteroids/body.svg",
		"images/asteroids/body-meatball.svg",
		"images/asteroids/crater.svg",
		"images/asteroids/crater-meatball.svg",
		"images/cossette/exhaust.svg",
		"images/cossette/hull.svg",
		"images/desolation/compass.svg",
		"images/desolation/plate.svg",
		"images/desolation/wave.svg",
		"images/icons/gps/component.svg",
		"images/icons/gps/cossette.svg",
		"images/icons/gps/meteorus.svg",
		"images/icons/gps/player.svg",
		"images/icons/gps/station.svg",
		"images/icons/resources/alloys.svg",
		"images/icons/resources/lightweaves.svg",
		"images/icons/resources/minerals.svg",
		"images/icons/resources/polymers.svg",
		"images/icons/chat.svg",
		"images/icons/dock.svg",
		"images/icons/energy.svg",
		"images/icons/gps.svg",
		"images/icons/healing.svg",
		"images/icons/health.svg",
		"images/icons/inventory.svg",
		"images/icons/profile.svg",
		"images/icons/refinery.svg",
		"images/icons/ship.svg",
		"images/icons/upgrader.svg",
		"images/icons/vulnerable.svg",
		"images/items/aluminum-chunk.svg",
		"images/items/aluminum-ore.svg",
		"images/items/cool-rock.svg",
		"images/items/cossettite.svg",
		"images/items/crude-oil.svg",
		"images/items/green-gem.svg",
		"images/items/gyroscope.svg",
		"images/items/platinum-chunk.svg",
		"images/items/platinum-ore.svg",
		"images/items/prank-video.svg",
		"images/items/red-gem.svg",
		"images/items/titanium-chunk.svg",
		"images/items/titanium-ore.svg",
		"images/items/yellow-gem.svg",
		"images/particles/beacony-call.svg",
		"images/particles/blaster.svg",
		"images/particles/sizy-blaster.svg",
		"images/particles/sleep.svg",
		"images/player/hull.svg",
		"images/player/exhaust.svg",
		"images/player/sphere.svg",
		"images/prankster/fortification.svg",
		"images/prankster/prankster.svg",
		"images/size-reversal/beacony.svg",
		"images/size-reversal/blaster.svg",
		"images/size-reversal/sizy.svg",
		"images/stations/action.svg",
		"images/stations/dock.svg",
		"images/stations/morse.svg",
		"images/stations/origin.svg",
		"images/arrow.svg",
		"images/blaster.svg",
		"images/meteorus.svg",
		"images/nanobots.svg",
		"images/star.svg",
		"images/star-outline.svg"
	])
	.load(setup);

function setup() {
	menu = new Menu();
	G.stage.addChild(menu.display);

	// Workaround for the PixiJS ticker CPU usage bug
	G.ticker.maxFPS = 144;
	G.ticker.add(tick);
}

function tick() {
	let screenSize = new Vector(window.innerWidth, window.innerHeight);
	G.renderer.resize(screenSize.x, screenSize.y);
	menu.update(G.ticker.deltaMS / 1000, screenSize, G.ticker.FPS);
	keyboard.clearStuff();
}
